var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMix = function SvgMix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.368 22.3319V27.7919C26.368 32.3519 24.548 34.1719 19.988 34.1719H14.548C10.008 34.1719 8.16797 32.3519 8.16797 27.7919V22.3319C8.16797 17.7919 9.98797 15.9719 14.548 15.9719H20.008C24.548 15.9719 26.368 17.7919 26.368 22.3319Z",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1678 14.5319V19.9919C34.1678 24.5519 32.3478 26.3719 27.7878 26.3719H26.3678V22.3319C26.3678 17.7919 24.5478 15.9719 19.9878 15.9719H15.9678V14.5319C15.9678 9.97188 17.7878 8.17188 22.3478 8.17188H27.8078C32.3478 8.17188 34.1678 9.99188 34.1678 14.5319Z",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.168 27.1719C41.168 34.9119 34.908 41.1719 27.168 41.1719L29.268 37.6719",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16797 15.1719C1.16797 7.43188 7.42797 1.17188 15.168 1.17188L13.068 4.67188",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMix;